module.exports = __webpack_public_path__ + "static/groningen-stukadoor-logo-32288ddc975c3b5d6bb26476dbbc25c3.png";